import axios from "axios";
import {
  SET_ERROR,
  SET_CHATLIST,
  SET_NEWSTATUS,
  SENDCHAT_SUCCESS,
  ENDCHAT_SUCCESS,
  MESSAGE_LIST,
  SET_CHATLIST_READCOUNT,
  ASSIGNED_AGENT,
  UPDATE_CHAT,
} from "../Types/ChatTypes";

const apiUrlChat = process.env.REACT_APP_API_URL + "chat/";

export const chatList = (
  currPage,
  viewType,
  checkchanges = false,
  search = ""
) => {
  return async (dispatch) => {
    try {
      const headerParameter = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      let searchParam = search === "" ? "" : "&search=" + search;
      const response = await axios.get(
        `${apiUrlChat}chatlist?page=` +
          currPage +
          "&limit=8&viewtype=" +
          viewType +
          searchParam,
        headerParameter
      );

      if (response.data.status) {
        let totalpages = parseInt(response.data.data.total_pages);
        let pages = parseInt(response.data.data.page);
        if (pages <= totalpages) pages += 1;
        dispatch({
          type: SET_CHATLIST,
          payload: {
            records: response.data.data.records,
            max: totalpages,
            page: pages,
            viewType: viewType,
            changes: checkchanges,
            isEmpty: response.data.data.total === 0 ? true : false,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: {
          errorMessage:
            "API chatList: " +
            (error.response
              ? error.response.data.error
              : error.message
              ? error.message
              : "Failed to send!"),
        },
      });
    }
  };
};

export const messageList = (chatID, Mpage, checkchanges = false) => {
  return async (dispatch) => {
    try {
      const headerParameter = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      const response = await axios.get(
        `${apiUrlChat}messagelist?chatlistid=` +
          chatID +
          "&page=" +
          Mpage +
          "&limit=10",
        headerParameter
      );
      if (response.data.status) {
        let Mmaxs = parseInt(response.data.data.total_pages);
        let Mpages = parseInt(response.data.data.page);
        if (Mpages <= Mmaxs) Mpages += 1;
        dispatch({
          type: MESSAGE_LIST,
          payload: {
            Mmax: Mmaxs,
            Mpage: Mpages,
            Mrecords: response.data.data.chatmessage,
            detailchat: response.data.data.detailchat[0],
            total: response.data.data.total,
            changes: checkchanges,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: {
          errorMessage:
            "API messageList: " +
            (error.response
              ? error.response.data.error
              : error.message
              ? error.message
              : "Failed to send!"),
        },
      });
    }
  };
};

export const historyList = async (chatID, Mpage) => {
  try {
    const headerParameter = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const response = await axios.get(
      `${apiUrlChat}messagelist?chatlistid=` +
        chatID +
        "&page=" +
        Mpage +
        "&limit=10",
      headerParameter
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API historyList: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed Fetch Data!"),
    };
  }
};

export const sendChat = (
  contactname,
  newchat,
  number,
  session,
  type,
  message,
  caption,
  filename,
  curChatID,
  campaignAssignmentID,
  campaignContactID,
  campaignID,
  phoneTypeID,
) => {
  return async (dispatch) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };

      const body = {
        contactname: contactname,
        newchat: newchat,
        number: number,
        session: session,
        type: type,
        caption: caption,
        filename: filename,
        message: message,
        campaignassignmentid: campaignAssignmentID,
        campaigncontactid: campaignContactID,
        campaignID: campaignID,
        phonetypeid: phoneTypeID,
        outboundContactID: campaignContactID,
        assignmentID: campaignAssignmentID,
      };

      const response = await axios.post(`${apiUrlChat}sendchat`, body, config);

      if (response.data.status) {
        dispatch({
          type: SENDCHAT_SUCCESS,
          payload: {
            contact: response.data.data.detailchat,
            message: response.data.data.chatmessage,
            curChatID: curChatID,
            newchat: newchat,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: {
          errorMessage:
            "API sendChat: " +
            (error.response
              ? error.response.data.error
              : error.message
              ? error.message
              : "Failed to send!"),
        },
      });
    }
  };
};

export const readchat = (chatID, session, number, source) => {
  return async (dispatch) => {
    try {
      const headerParameter = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      const bodyParameters = {
        chatlistid: chatID,
        session: session,
        number: number ? number : 10,
        chatsource: source,
      };
      const response = await axios.post(
        `${apiUrlChat}readchat`,
        bodyParameters,
        headerParameter
      );
      if (response.data.status) {
        dispatch({
          type: SET_NEWSTATUS,
          payload: {
            chatListID: response.data.data.ChatListID,
            statusID: response.data.data.StatusID,
            statusName: response.data.data.StatusName,
            emit: true,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: {
          errorMessage:
            "API readChat: " +
            (error.response
              ? error.response.data.error
              : error.message
              ? error.message
              : "Failed!"),
        },
      });
    }
  };
};

export const getSessionList = async () => {
  try {
    const headerParameter = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const response = await axios.get(
      `${apiUrlChat}getSession`,
      headerParameter
    );
    if (response.data.status) {
      return response.data;
    }
  } catch (error) {
    return {
      status: false,
      error:
        "API getSessionList: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getContactList = async (session, type, param) => {
  try {
    const headerParameter = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    let name = "",
      number = "";
    if (type === "contactname") {
      name = param;
    }
    if (type === "number") {
      number = param;
    }
    const response = await axios.get(
      `${apiUrlChat}SearchContact?session=` +
        session +
        "&name=" +
        name +
        "&number=" +
        number,
      headerParameter
    );
    if (response.data.status) {
      return response.data;
    }
  } catch (error) {
    return {
      status: false,
      error:
        "API getContactList: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getFileMedia = async (filename, session) => {
  try {
    const headerParameter = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const response = await axios.get(
      `${apiUrlChat}getFileMedia?filename=` + filename + "&session=" + session,
      headerParameter
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      error: error.response
        ? "getFileMedia " + error.response.data.error
        : "getFileMedia Failed!",
    };
  }
};

export const contactInfoHistory = async (id, contactId, session) => {
  try {
    const headerParameter = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    console.log("hello:", id, contactId, session);
    const response = await axios.get(
      `${apiUrlChat}contactInfoHistory?chatlistid=` +
        id +
        "&contactId=" +
        contactId +
        "&session=" +
        session,
      headerParameter
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API contactInfoHistory: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed Fetch Data!"),
    };
  }
};

export const endChat = (
  ChatListID,
  session,
  detailchat,
  detailcontact,
  type,
  CaseID,
  AssignmentID,
  ISCode,
  ISCodeReason,
  chatSource,
  remarks
) => {
  return async (dispatch) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };

      const body = {
        session: session,
        chatlistid: ChatListID,
        type: type,
        caseid: CaseID,
        assignmentid: AssignmentID ?? detailchat.AssignmentID,
        iscode: ISCode,
        iscodereason: ISCodeReason,
        chatsource: chatSource,
        outboundcontactid: detailchat.OutboundContactID,
        campaignid: detailchat.CampaignID,
        remarks: remarks,
      };

      const response = await axios.post(
        `${apiUrlChat}endsession`,
        body,
        config
      );

      if (response.data.status) {
        dispatch({
          type: ENDCHAT_SUCCESS,
          payload: {
            ChatListID:
              chatSource === "WA"
                ? response.data.ChatListID
                : ChatListID,
            detailchat: detailchat,
            contact: detailcontact,
            emit: true,
          },
        });

        // Refresh chat list and message list
        dispatch({ type: UPDATE_CHAT });
      }
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: {
          errorMessage:
            "API endChat: " +
            (error.response
              ? error.response.data.error
              : error.message
              ? error.message
              : "Failed to send!"),
        },
      });
    }
  };
};

export const getCountList = () => {
  return async (dispatch) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      const response = await axios.get(`${apiUrlChat}getcountlist`, config);
      if (response.data.status) {
        dispatch({
          type: SET_CHATLIST_READCOUNT,
          payload: response.data.data,
        });
      }
    } catch (error) {
      return { status: false };
    }
  };
};

export const checkChatActive = async (session, number) => {
  try {
    number = number.startsWith("62") ? number : "62" + number;
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const response = await axios.get(
      `${apiUrlChat}checkchatactive?session=` + session + "&number=" + number,
      config
    );
    if (response.data.status) {
      return response.data;
    }
  } catch (error) {
    return {
      status: false,
      error:
        "API checkChatActive: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getContactDetail = async (campaignid, contactid, assignmentid) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const response = await axios.get(
      `${apiUrlChat}getdetailcontact?campaignid=` +
        campaignid +
        "&contactid=" +
        contactid +
        "&assignmentid=" +
        assignmentid,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API getContactDetail: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getActionLog = async (contactid, page) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const response = await axios.get(
      `${apiUrlChat}getactionlog?contactid=` +
        contactid +
        "&page=" +
        page +
        "&limit=10",
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API getActionLog: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getListStatus = async (CampaignID, typeStatus, StatusID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const response = await axios.get(
      `${apiUrlChat}getliststatus?campaignid=` +
        CampaignID +
        "&type=" +
        typeStatus +
        "&status=" +
        StatusID,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API getListStatus: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getListTicket = async (page, search) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const response = await axios.get(
      `${apiUrlChat}getlistticket?page=` +
        page +
        "&search=" +
        search +
        "&limit=10",
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API getListTicket: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getAssignedAgent = async (session) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const response = await axios.get(
      `${apiUrlChat}getAssignedAgent?session=` + session,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API getAssignedAgent: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const setAssignedAgent = (ChatListID, AgentID) => {
  return async (dispatch) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      const body = {
        chatlistid: ChatListID.toString(),
        agentid: AgentID,
      };
      const response = await axios.post(
        `${apiUrlChat}setAssignedAgent`,
        body,
        config
      );
      if (response.data.status) {
        dispatch({
          type: ASSIGNED_AGENT,
          payload: {
            detailchat: response.data.data.detailchat,
            emit: true,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: SET_ERROR,
        payload: {
          errorMessage:
            "API PostAssignedAgent: " +
            (error.response
              ? error.response.data.error
              : error.message
              ? error.message
              : "Failed to get data!"),
        },
      });
    }
  };
};

// Chat internal
export const sendInternalBroadcastMessage = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrlChat}sendinternalbroadcastmessage`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API sendInternalBroadcastMessage: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const sendInternalMessage = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrlChat}sendinternalmessage`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API sendInternalMessage: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const readInternalMessage = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrlChat}readinternalmessage`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API readInternalMessage: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const selectContact = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrlChat}selectcontact`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API selectContact: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getChatTags = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    const response = await axios.get(
      `${apiUrlChat}getchattags`,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,
      error:
        "API getChatTags: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const upsertChatTags = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrlChat}upsertchattags`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API upsertChatTags: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getHistoryChat = async (chatSource, chatListID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlChat}getHistoryChat?chatsource=` +
        chatSource +
        "&chatlistid=" +
        chatListID,

      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getHistoryChat: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};
